export const APISessionError = (axiosError: any) => {
    if (axiosError && axiosError.response && axiosError.response.status === 401) {
        window.localStorage.removeItem('RAW_SESSION');
        window.location.reload();
    }
};